const XML_MIME_TYPES = [
    'application/xml',
    'text/xml',
    'application/ubl+xml',
];

export function isXmlMimeType(mimetype?: string | null): boolean {
    if (!mimetype) {
        return false;
    }

    const normalized = mimetype.toLowerCase().trim().split(';')[0].trim();

    return XML_MIME_TYPES.includes(normalized) || normalized.endsWith('+xml');
}
